import { render, staticRenderFns } from "./CustomerSalesorderTable.vue?vue&type=template&id=3ee842e9&scoped=true&"
import script from "./CustomerSalesorderTable.vue?vue&type=script&lang=js&"
export * from "./CustomerSalesorderTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSalesorderTable.vue?vue&type=style&index=0&id=3ee842e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee842e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDataTable,VLayout,VRow})
